// .u_amo-pagehead
class UAMOPageHead extends Uneet {
  constructor (domElement) {
    super(domElement)
    this.navIsOpen = false
    this.__init()
  }
  __init () {
    this._e.querySelector('a.btn.navbar-toggle').onClick((ev) => {
      this.__toggleNav()
    })
    this.__toggleNav(false)
  }
  __toggleNav (force = null) {
    this.navIsOpen = (force === null) ? !this.navIsOpen : force
    this._e.querySelector('#main-nav').toggleClass('isOpen', this.navIsOpen)
  }
}
